import { Header } from '@/components/Header';
import { ExecutiveSummaryDateCompare } from '@/dashboards/ExecutiveSummary/components/ExecutiveSummaryDateCompare';
import { ExecutiveSummaryContextProvider } from '@/dashboards/ExecutiveSummary/context';
import { GeneralSummaryCharts } from '@/dashboards/ExecutiveSummary/components/GeneralSummaryCharts';
import { CompetitorImpactCharts } from '@/dashboards/ExecutiveSummary/components/CompetitorImpactCharts';
import { InfoIcon } from '@analytical-alley/ui';
import { Can, FEATURE_FLAG_ACTIONS, FEATURE_FLAG_SUBJECTS } from '@/features/Casl';

export const ExecutiveSummary = () => {
    return (
        <ExecutiveSummaryContextProvider>
            <Header
                className="pb-6 px-16 pt-6 h-auto min-h-28"
                title="Executive Summary"
                sticky
            >
                <div className="h-full flex gap-2 items-center">
                    <InfoIcon>
                        The data is not updated in real time. <br /> It only
                        refreshes when the model itself is updated.
                    </InfoIcon>
                    <ExecutiveSummaryDateCompare />
                </div>
            </Header>
            <div className="flex flex-col justify-start gap-4 w-full pb-8 px-8 lg:px-16">
                <Can
                    I={FEATURE_FLAG_ACTIONS.VIEW}
                    a={
                        FEATURE_FLAG_SUBJECTS.EXECUTIVE_SUMMARY_DASHBOARD_GENERAL_SUMMARY
                    }
                >
                    <GeneralSummaryCharts />
                </Can>
                <Can
                    I={FEATURE_FLAG_ACTIONS.VIEW}
                    a={
                        FEATURE_FLAG_SUBJECTS.EXECUTIVE_SUMMARY_DASHBOARD_COMPETITOR_IMPACT
                    }
                >
                    <CompetitorImpactCharts />
                </Can>
            </div>
        </ExecutiveSummaryContextProvider>
    );
};
